import BackArrowIcon from '@icons/arrow-left.svg?react'
import { tr } from 'mmfintech-commons'
import { MMArrowButton as LibraryButton } from 'mmfintech-portal-commons'
import type { MMArrowButtonProps } from 'mmfintech-portal-commons/types'

const MMArrowButton = (props: Partial<MMArrowButtonProps>) => (
  <LibraryButton leftIcon={BackArrowIcon} text={tr('FRONTEND.BUTTONS.BACK', 'Back')} {...props} />
)

export default MMArrowButton
